import React, { useEffect, useState } from "react";
import { Card, Table, Tooltip, Button, Tag } from "antd";
import { EditFilled } from "@ant-design/icons";
import { isValidValue, setFormFieldValue } from "../../../helpers/FormHelper";
import moment from "moment";
import ErrorCard from "../../../components/Common/Cards/ErrorCard";
import { EmptyTable } from "../../Election/Patronage/PatronageReferred/voters-list/components/List";



export const generateVoterSafetyTag = (rating) => {
    switch (rating) {
        case 1:
            return <Tag className="font-weight-bold m-0" color="green">I sigurtë</Tag>
        case 2:
            return <Tag className="font-weight-bold m-0" color="orange">I pasigurtë</Tag>
        case 3:
            return <Tag className="font-weight-bold m-0" color="gold">I lëkundur</Tag>
        default:
            return null;
    }
}



const List = ({ dispatch, items, totalCount, initialPagination, loading, errorMessage, setLoadingType, onSuccess }) => {


    const [paginationTable, setPaginationTable] = useState({
        showSizeChanger: true,
        pageSizeOptions: [5, 10, 15, 20, 25],
        pageSize: initialPagination.pageSize,
        current: initialPagination.currentPage,
        total: totalCount,
        showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
    });


    useEffect(() => {
        setPaginationTable({
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 15, 20, 25],
            pageSize: initialPagination.pageSize,
            current: initialPagination.currentPage,
            total: totalCount,
            showTotal: (total, range) => `${range[0]}-${range[1]} nga ${total} `,
        });
    }, [initialPagination, totalCount]);


    const handleTableChange = (pagination, filters, sorter) => {
        setLoadingType(null);
        const action = {
            type: "set_table_pagination",
            payload: {
                pageSize: pagination.pageSize,
                currentPage: pagination.current,
            },
        };
        dispatch(action);
    };


    const tableColumns = [
        {
            title: "#",
            dataIndex: "row_number",
            key: "row_number",
            width: 70,
            align: "center",
            render: (value) => <b>{value + "."}</b>,
        },
        {
            title: "Emri",
            dataIndex: "name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.name)
        },
        {
            title: "Mbiemri",
            dataIndex: "surname",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.surname)
        },
        {
            title: "Atësia",
            dataIndex: "father_name",
            align: 'left',
            width: 150,
            render: (_, elm) => setFormFieldValue(elm?.voter?.father_name)
        },
        {
            title: "Datëlindja",
            dataIndex: "dob",
            align: 'center',
            width: 120,
            render: (_, elm) => isValidValue(elm?.voter?.dob) ? moment(elm?.voter?.dob).format("DD-MM-YYYY") : null
        },
        {
            title: "Gjinia",
            dataIndex: "gender",
            align: 'center',
            width: 100,
            render: (_, elm) => setFormFieldValue(elm?.voter?.gender)
        },
        {
            title: "QV",
            dataIndex: "qv",
            align: 'center',
            width: 100,
            render: (_, elm) => setFormFieldValue(elm?.voter?.qv?.code)
        },
        {
            title: "Preferenca politike",
            dataIndex: "preference",
            align: 'center',
            width: 180,
            render: (text, record) => <b>{setFormFieldValue(record?.political_preference?.name)}</b>,
        },
        {
            title: "Siguria e votuesit",
            dataIndex: "safety",
            align: 'center',
            width: 180,
            render: (text, record) => generateVoterSafetyTag(record?.safety_rating),
        },
        {
            title: "Modifiko",
            dataIndex: "actions",
            align: "center",
            width: 90,
            fixed: "right",
            className: "bg-white m-0 p-0",
            render: (_, elm) => (
                <div className="p-2" style={{ backgroundColor: "#fff" }}>
                    <Tooltip title="Modifiko">
                        <Button
                            type="primary"
                            onClick={() => openView(elm, 1)}
                            icon={<EditFilled />}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];


    const openView = (item, index) => {
        const action = {
            type: 'open_view',
            payload: {
                item: item,
                index: index
            }
        };
        dispatch(action);
    };


    return (
        <Card style={{ borderRadius: "0", marginBottom: '0' }} bodyStyle={{ padding: "0" }}>
            <div className="table-responsive">
                <Table
                    size="small"
                    className="striped-table"
                    columns={tableColumns}
                    rowKey="id"
                    loading={loading}
                    dataSource={items}
                    pagination={paginationTable}
                    onChange={handleTableChange}
                    scroll={{ x: 1200 }}
                    showHeader="true"
                    locale={{
                        emptyText: errorMessage ? (
                            <ErrorCard message={errorMessage} />
                        ) : (
                            EmptyTable
                        ),
                    }}
                />
            </div>
        </Card>
    );
};

export default List;
